import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ApiService {
  constructor(private http: HttpClient) {}

  getSubLevelNames(unitId: number): Observable<any> {
    return this.http.get(`${environment.baseUrl}/api/church-unit-levels/unit/${unitId}/sub-level-names`);
  }
}
